"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _Modal = require("../../molecules/Modal");

var _TBSoccerSpotlight = _interopRequireDefault(require("../../assets/img/TB-soccer-spotlight.png"));

require("./ConfirmationModal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var ConfirmationModal = function ConfirmationModal(_ref) {
  var onCloseClick = _ref.onCloseClick,
      goToTraceId = _ref.goToTraceId;

  var onGoToTraceIdClick = function onGoToTraceIdClick(e) {
    if (goToTraceId) {
      goToTraceId(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    open: true,
    className: "confirmation-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.TitleSection, {
    onCloseClick: onCloseClick
  }, /*#__PURE__*/_react.default.createElement(_Modal.ModalTitle, {
    content: "Moment personalized!"
  })), /*#__PURE__*/_react.default.createElement(_Modal.ContentSection, null, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "confirmation-image",
    marginTop: "16",
    marginBottom: "12"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _TBSoccerSpotlight.default,
    alt: "tracebot-knee"
  }))), /*#__PURE__*/_react.default.createElement(_Modal.FooterSection, null, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    className: "go-back-button",
    trkAction: "Back to game Pressed",
    content: "Go back to the game",
    width: "100%",
    onClick: onCloseClick
  }), /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    className: "go-to-trace-id-button",
    trkAction: "See it on Trace iD Pressed",
    primary: true,
    content: "See it on my Trace iD",
    width: "100%",
    onClick: onGoToTraceIdClick
  })));
};

exports.ConfirmationModal = ConfirmationModal;